const resolvePlaceName = (location) => location?.cityName || location?.city || location?.name || '';

/**
 * Resolves origin or destination city name from departs trip data.
 * @param {object} departs - Purchase departs leg.
 * @param {'origin'|'destination'} place - Place field to resolve.
 * @returns {string} City name or empty string.
 */
const getPlaceName = (departs, place) =>
  resolvePlaceName(departs[place]) || resolvePlaceName(departs.fragments?.[0]?.[place]);

/**
 * Resolves the destination city name from purchase departs data.
 * @param {object} purchase - Purchase object.
 * @returns {string} Destination city name or empty string.
 */
export const getPurchaseDestinationName = (purchase = {}) => {
  const departs = purchase.departs || {};
  return getPlaceName(departs, 'destination');
};

/**
 * Resolves the origin city name from purchase departs data.
 * @param {object} purchase - Purchase object.
 * @returns {string} Origin city name or empty string.
 */
export const getPurchaseOriginName = (purchase = {}) => {
  const departs = purchase.departs || {};
  return getPlaceName(departs, 'origin');
};
